export default __webpack_public_path__ + "images/plot-type-deep-stacked-bar.026de7aa953b5941a3a8ad2eadc9b799.svg";